
define('text!templates/modules/calendar/favorite/edit/form/favorite-edit-form.html',[],function () { return '<div class="name-input"></div>\n';});

